const showTextRole = (roles) => {
  if (roles.length >= 3) {
    return `${roles
      .slice(0, 2)
      .map((r) => r.name)
      .join(", ")} ... +${roles.length - 2} another`;
  }
  return roles.map((r) => r.name).join(", ");
};

export const mapDepartmentToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfEmployee: item?.employees?.length,
    roleText: showTextRole(item.roles),
  }));

  return result;
};

export const departmentColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "description", label: "Description", align: "center" },
  { key: "roleText", label: "Roles", align: "center" },
  {
    key: "numOfEmployee",
    label: "Number Of Employee",
    align: "center",
  },
];
